import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Radio from 'antd/lib/radio';
import {
  currencyFormatter,
  formatMonthsQuantity,
  formatMonthsCount,
  percentageFormatter,
  tranaslatedDistanceInWordsToNow,
} from '../../../common/utils/helpers';
import config from '../../../config';
import { loanGoalsT } from '../../../common/enums';
import allocationRules from '../../../common/rules/allocationRules';
import rules from '../../../common/rules/rules';
import { paymentDestinationT } from '../../../common/enums';
import DurationFilter from './filters/Duration';
import AmountFilter from './filters/Amount';
import InterestFilter from './filters/Interest';
import RemainingAmountFilter from './filters/RemainingAmount';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

@translate()
@Form.create()
export default class CreateManualAllocationMobile extends Component {
  static propTyes = {
    accountBalance: PropTypes.number.isRequired,
    expandedRowKeys: PropTypes.array.isRequired,
    expectedRevenues: PropTypes.object.isRequired,
    fetchAndAppend: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    loans: PropTypes.array.isRequired,
    onAllocationAmountChange: PropTypes.func.isRequired,
    onRowClick: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onResetFilters: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    totalLoans: PropTypes.number.isRequired,
    validateAndSubmit: PropTypes.func.isRequired,
  };

  render() {
    const {
      accountBalance,
      expandedRowKeys,
      expectedRevenues,
      fetchAndAppend,
      form,
      loans,
      onAllocationAmountChange,
      onRowClick,
      t,
      totalLoans,
      validateAndSubmit,
      filter,
      onFilterChange,
      onResetFilters,
      minMonths,
      maxMonths
    } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <section className="manual-allocation-mobile">
        <div className="manual-allocation-filters">
          <DurationFilter onChange={onFilterChange} value={filter.termMonthsMin} minMonths={minMonths} maxMonths={maxMonths} />
          <AmountFilter
            min={config.manualAllocationFilterSettings.amountMin}
            max={config.manualAllocationFilterSettings.amountMax}
            step={config.manualAllocationFilterSettings.amountStep}
            onChange={onFilterChange}
            value={[filter.amountMin, filter.amountMax]}
          />
          <InterestFilter
            min={config.manualAllocationFilterSettings.interestMin}
            max={config.manualAllocationFilterSettings.interestMax}
            step={config.manualAllocationFilterSettings.interestStep}
            onChange={onFilterChange}
            value={[filter.interestMin, filter.interestMax]}
          />
          <RemainingAmountFilter
            min={config.manualAllocationFilterSettings.remainingAmountMin}
            max={config.manualAllocationFilterSettings.remainingAmountMax}
            step={config.manualAllocationFilterSettings.remainingAmountStep}
            onChange={onFilterChange}
            value={[filter.remainingAmountMin, filter.remainingAmountMax]}
          />
          <Button size="small" onClick={onResetFilters}>
            {t('Resetovať filtre')}
          </Button>
        </div>

        <Form>
          {loans.map(loan => {
            const isExpanded = expandedRowKeys.indexOf(loan.id) !== -1;
            return (
              <article key={loan.id}>
                <div>
                  <div className="flex-row info">
                    <p>{t('Typ pôžičky')}</p>
                  </div>
                  <div className="flex-row data">
                    <p>
                      <strong>
                        {t('na')} "{loanGoalsT[loan.goal]}"
                      </strong>
                    </p>
                  </div>
                  <div className="flex-row info">
                    <p>{t('Suma pôžičky')}</p>
                    <p>{t('Výnos p.a.')}</p>
                  </div>
                  <div className="flex-row data">
                    <p>
                      <strong>{currencyFormatter(loan.amount)}</strong>
                    </p>
                    <p>
                      <strong>{percentageFormatter(loan.interest)}</strong>
                    </p>
                  </div>
                  <div className="flex-row info">
                    <p>{t('Splatnosť')}</p>
                    <p>{t('Do zaplnenia')}</p>
                  </div>
                  <div className="flex-row data">
                    <p>
                      <strong>{`${formatMonthsCount(loan.months)} ${formatMonthsQuantity(
                        loan.months
                      )}`}</strong>
                    </p>
                    <p>
                      <strong>{currencyFormatter(loan.remainingAmount)}</strong>
                    </p>
                  </div>
                </div>
                <div className="remaining">
                  <p>
                    <strong>
                      {t('Ostáva')} {tranaslatedDistanceInWordsToNow(loan.expirationDate)}
                    </strong>
                  </p>
                  {!isExpanded && (
                    <Button onClick={() => onRowClick(loan)} type="danger">
                      {t('Vybrať')}
                    </Button>
                  )}
                </div>
                {isExpanded && (
                  <div className="input-section">
                    <div className="input-field">
                      <label className="ant-form-item-required">{t('Suma')}</label>
                      <FormItem>
                        {getFieldDecorator(`amount[${loan.id}]`, {
                          rules: allocationRules.amountFitsInAccoutBalance(
                            form,
                            accountBalance,
                            loan.remainingAmount
                          ),
                          initialValue: loan.remainingAmount
                        })(
                          <Input
                            size="default"
                            disabled={true}
                          />
                        )}
                      </FormItem>
                    </div>
                    <div className="allocation-actions">
                      <div>
                        <a onClick={() => onRowClick(loan)}>
                          <strong>{t('Zavrieť')}</strong>
                        </a>
                      </div>
                      <div>
                        <Button
                          onClick={() => validateAndSubmit(loan, form)}
                          htmlType="submit"
                          type="danger"
                        >
                          {t('Investovať')}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </Form>
        {loans.length !== totalLoans && (
          <div className="load-more">
            <Button onClick={fetchAndAppend} type="danger">
              {t('Načítať viac')}
            </Button>
          </div>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/CreateManualAllocationMobile.js